import Vue from 'vue'
import _ from 'underscore'

export default {

    namespaced: true,

    state: {

        data: {}

    },

    getters: {

        all: function(state) {

            return state.data

        },

        overview: function(state) {

            return state.data.overview || []

        },

        heatmap: function(state) {

            return state.data.heatmap || []

        },

        groups: function(state) {

            return state.data.groups || []

        },

        games: function(state) {

            return state.data.games || []

        },

        recent: function(state) {

            return state.data.recent || []

        },

        player: function(state) {

            return state.data.player || []

        },

        weight: function(state) {

            return state.data.weight || []

        },

        counts: function(state) {

            return state.data.counts || []

        },

        duration: function(state) {

            return state.data.duration || []

        },

        wins: function(state) {

            return state.data.wins || []

        }

    },

    mutations: {

        reset: function(state) {

            state.data = {}

        },

        set: function(state, data) {

            _.each(data, function(value, key) {

                Vue.set(state.data, key, value)

            })

        }

    },

    actions: {}

}